const fragmentShader = `
varying vec3 vWorldNormal;
varying vec3 vWorldPosition;
varying vec3 vLookDirection;
varying vec2 vUv;

uniform sampler2D nftMap;
uniform sampler2D liquidNoiseMap;

uniform vec2 resolution;
uniform float showNormal;
uniform float opacity;
uniform float time;
uniform float distortion;
uniform float transitionValue;
uniform float faceID;
uniform vec2 aspectRatio;

float fresnel(vec3 eyeVector, vec3 worldNormal) {

	return pow( 1.0 + dot( eyeVector, worldNormal ), 4.0 );

}

float roundedBoxSDF( vec2 centerPosition, vec2 size, float radius ) {

    return length( max( abs( centerPosition ) - size + radius, 0.0 ) ) - radius;

}

void main() {

  vec2 nftUV = vUv;
  //nftUV.y = 1.0 - nftUV.y;

  nftUV -= vec2(0.5);
  nftUV *= aspectRatio;
  nftUV += vec2(0.5);

  float t = ( 1.0 - transitionValue ) + 0.001;

  float pixelSize = 200. * t;

  vec2 distortUV = texture2D( liquidNoiseMap, ( ( nftUV + vec2( faceID ) ) * 0.7 ) + ( time * 0.4 ) ).rg;
  vec2 distortUVB = texture2D( liquidNoiseMap, ( ( nftUV + vec2( faceID ) * 1.3 ) ) - ( time * 0.4 ) ).rg;

  distortUV = mix( distortUV, distortUVB, 0.5 );

 
  vec2 newUV = floor( nftUV * 1024. / pixelSize ) / 1024. * pixelSize;

  nftUV += ( ( distortUV * 2.0 - 1.0 ) * ( (distortion * 0.5) ) ) * 0.1;

  vec4 nftTexture = texture2D( nftMap, nftUV + ( ( distortUV * 2.0 - 1.0 ) * ( 1.0 - transitionValue ) ) * 0.1 );

  vec3 lookDirection = normalize( vLookDirection + ( vec3( distortUV, 0.0 ) * ( 1.0 - transitionValue ) ) );

  float f = fresnel( lookDirection, normalize( vWorldNormal ) );
  float r = 1.0 - smoothstep( 0.0, 0.01, roundedBoxSDF( vUv - vec2( 0.5 ), vec2( 0.475 ), 0.03 ) );

  vec3 outColor = mix( vec3( 1.0 ), nftTexture.rgb, 1.0 - f );

  gl_FragColor = vec4( outColor, r * opacity );
  // gl_FragColor = vec4(textureLoaded, 0.0, 0.0, 1.0);

}`;

export default fragmentShader;
